import type { CascaderOption } from "@reactive-resume/ui";
import { chinaRegions } from "./china-regions";

// 将现有的中国地区数据转换为 Cascader 组件所需的格式
export const chinaCascaderData: CascaderOption[] = chinaRegions.map(province => ({
  value: province.code,
  label: province.name,
  children: province.cities.map(city => ({
    value: city.code,
    label: city.name
  }))
}));

// 根据选择的值获取完整的地址字符串
export const getCascaderDisplayText = (values: string[]): string => {
  if (values.length === 0) return "";
  
  const [provinceCode, cityCode] = values;
  const province = chinaRegions.find(p => p.code === provinceCode);
  
  if (!province) return "";
  
  if (values.length === 1) {
    return province.name;
  }
  
  const city = province.cities.find(c => c.code === cityCode);
  return city ? `${province.name} ${city.name}` : province.name;
};